import React from 'react';
import { Switch, Route } from 'react-router-dom';
import New from './New';
import View from './View';
import Update from './Update';
import List from './List';
const Students = ({ match }) => {
  return (
    <Switch>
      <Route path={`${match.url}/view`} component={View} />
      <Route path={`${match.url}/new`} component={New} />
      <Route path={`${match.url}/update`} component={Update} />

      <Route path={`${match.url}`} component={List} />
    </Switch>
  );
};

Students.propTypes = {};

export default Students;
